import React, { useEffect, useState } from "react";
import { Form, Button, Spinner, Container, Row, Col } from "react-bootstrap";
import { Redirect, useHistory } from "react-router-dom";
import axios from "axios";
import { useForm } from "react-hook-form";
import { FaTrash } from "react-icons/fa";
import ReactTooltip from "react-tooltip";
const { parseCookies } = require("nookies");

const UpdateTreatment = (props) => {
    const history = useHistory();
    const cookies = parseCookies();
    const id = props.match.params.id;

    const [treatment, setTreatment] = useState({});
    const [loading, setLoading] = useState(false);
    const [deleted, setDeleted] = useState(false);
    const [showErr, setErr] = useState("");
    const [showSucc, setSucc] = useState("");

    const { register, handleSubmit, errors } = useForm();

    // fetch trattamento singolo
    useEffect(() => {
        let mounted = true;
        const fetch = async () => {
            try {
                const res = await axios.get(`${window.$apiEndpoint}/treatments/fetch/${id}`, {
                    headers: { "x-access-token": cookies.token }
                });
                if (mounted) {
                    setTreatment(res.data?.[0] || res.data || {});
                    setLoading(true);
                }
            } catch (e) {
                console.log(e);
                setErr("Errore nel caricamento trattamento");
                setLoading(true);
            }
        };
        fetch();
        return () => { mounted = false; };
    }, [cookies.token, id]);

    // submit update
    const onSubmit = async (data) => {
        setErr("");
        setSucc("");

        // 🔁 campo ID reale
        const treatmentId = data.id;
        if (!treatmentId) {
            return setErr("Trattamento non selezionato");
        }

        const confirmation = window.confirm("Sei sicuro di voler modificare il trattamento selezionato?");
        if (!confirmation) return;

        const payload = {
            id: treatmentId,
            name: data.name?.trim(),
            price: data.price,
            notes: data.notes?.trim(),
        };

        try {
            await axios.post(`${window.$apiEndpoint}/treatments/update`, payload, {
                headers: { "x-access-token": cookies.token }
            });

            setSucc("Trattamento modificato con successo, a breve la pagina verrà ricaricata.");
            setTimeout(() => setDeleted(true), 1500);
        } catch (e) {
            console.log(e);
            setErr("Errore - " + e.message);
        }
    };

    const handleDelete = async () => {
        setErr("");
        setSucc("");

        const confirmation = window.confirm(
            "Questa azione cancellerà il trattamento. Sei sicuro di voler procedere?"
        );
        if (!confirmation) return;

        try {
            await axios.delete(
                `${window.$apiEndpoint}/treatments/delete/${id}`,
                { headers: { "x-access-token": cookies.token } }
            );

            setSucc("Trattamento eliminato con successo, a breve la pagina verrà ricaricata.");
            setTimeout(() => setDeleted(true), 1500);
        } catch (e) {
            console.log(e);
            if (e.response?.status === 409) {
                setErr(e.response.data.message);
            } else {
                setErr("Errore - " + e.message);
            }
        }
    };

    if (deleted) {
        return <Redirect to="/treatments" />;
    }

    return (
        <Container fluid>
            <Row>
                <Col xs={12} className="card border-left-warning shadow h-100 py-6 px-4">
                    {!loading ? (
                        <center><Spinner animation="border" /></center>
                    ) : (
                        <>
                            <div className="d-flex align-items-center my-3">
                                <h4 className="mb-2">Dettaglio Trattamento</h4>

                                <ReactTooltip />
                                {/* Bottone elimina TONDO con tooltip */}
                                <div className="ml-auto d-flex align-items-center">
                                    <p data-tip="Elimina trattamento" className="mb-0">
                                        <Button
                                            size="sm"
                                            variant="danger"
                                            style={{
                                                borderRadius: "2rem",
                                                paddingLeft: "1.2rem",
                                                paddingRight: "1.2rem",
                                                paddingTop: "0.7rem",
                                                paddingBottom: "0.7rem",
                                            }}
                                            onClick={handleDelete}
                                        >
                                            <FaTrash />
                                        </Button>
                                    </p>
                                </div>
                            </div>

                            <Form onSubmit={handleSubmit(onSubmit)}>
                                {/* hidden id */}
                                <Form.Control
                                    type="hidden"
                                    name="id"  // 🔁 se usi _id o codice_trattamento cambia qui e nel payload
                                    ref={register({ required: true })}
                                    defaultValue={treatment.id || treatment._id || treatment.codice_trattamento}
                                />

                                <Form.Row>
                                    <Form.Group controlId="name" as={Col}>
                                        <Form.Label>Nome</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="name"
                                            ref={register({ required: true })}
                                            defaultValue={treatment.name}
                                        />
                                        {errors.name && (
                                            <p style={{ marginTop: "1vh", fontWeight: "bold", color: "#f15a24" }}>
                                                Il campo è obbligatorio
                                            </p>
                                        )}
                                    </Form.Group>

                                    <Form.Group controlId="price" as={Col}>
                                        <Form.Label>Tariffa Oraria (€/ora)</Form.Label>
                                        <Form.Control
                                            type="text"
                                            name="price"
                                            ref={register({ required: true })}
                                            defaultValue={treatment.price}
                                        />
                                        <small>Inserire numero con il punto es. 39.50</small>
                                        {errors.price && (
                                            <p style={{ marginTop: "1vh", fontWeight: "bold", color: "#f15a24" }}>
                                                Il campo è obbligatorio
                                            </p>
                                        )}
                                    </Form.Group>
                                </Form.Row>

                                <Form.Row>
                                    <Form.Group controlId="notes" as={Col}>
                                        <Form.Label>Note</Form.Label>
                                        <Form.Control
                                            as="textarea"
                                            rows={4}
                                            name="notes"
                                            ref={register({})}
                                            defaultValue={treatment.notes}
                                        />
                                    </Form.Group>
                                </Form.Row>

                                <p style={{ marginTop: "1vh", fontWeight: "bold", color: "red" }}>{showErr}</p>
                                <p style={{ marginTop: "1vh", fontWeight: "bold", color: "green" }}>{showSucc}</p>

                                <Button
                                    variant="info"
                                    size="md"
                                    type="submit"
                                    style={{ backgroundColor: "#009688", borderColor: "#009688", fontWeight: "600" }}
                                >
                                    Modifica Trattamento
                                </Button>

                                <Button
                                    variant="secondary"
                                    size="md"
                                    className="ml-2"
                                    onClick={() => history.push("/treatments")}
                                >
                                    Indietro
                                </Button>
                            </Form>
                        </>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default UpdateTreatment;
